import { render, staticRenderFns } from "./Product-XQTX.vue?vue&type=template&id=e8fff944&scoped=true"
import script from "./Product-XQTX.vue?vue&type=script&lang=js"
export * from "./Product-XQTX.vue?vue&type=script&lang=js"
import style0 from "./Product-XQTX.vue?vue&type=style&index=0&id=e8fff944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fff944",
  null
  
)

export default component.exports